import { gql } from '@/__generated__';

const GET_DEVICE_CERTIFICATE_EXISTS = gql(`
  query DeviceConfiguration_GetDeviceCertificateExists($deviceId: ID!) {
    deviceCertificateExists(deviceId: $deviceId)
  }
`);

export default GET_DEVICE_CERTIFICATE_EXISTS;
